<template>
  <ContentPage back>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">{{ me.name }}</div>
    </template>
    <div class="d-flex flex-column">
      <ContactSection :user="me"/>
      <W9Section v-if="w9" :w9="w9" />
      <NoW9Section v-else />
    </div>
  </ContentPage>
</template>

<script>

import { ContentPage } from '@/components/pages'
import ContactSection from './sections/Contact'
import NoW9Section from './sections/NoW9'
import W9Section from './sections/W9'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    ContentPage,
    ContactSection,
    NoW9Section,
    W9Section,
  },
  
  computed: {
    ...mapGetters('auth', ['me', 'w9'])
  },

  methods: {
    ...mapActions('auth', ['loadMe', 'loadW9']),
  },

  created() {
    this.loadMe()
    this.loadW9()
  }
}
</script>